import React, { useEffect } from 'react';
import { SignIn, useUser } from '@clerk/clerk-react';
import { Footerdemo } from './ui/footer-section';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { isSignedIn, user } = useUser();
  const navigate = useNavigate();

  // Get user service tier from private metadata
  const userTier = user?.privateMetadata?.serviceTier as string | undefined;
  
  useEffect(() => {
    if (isSignedIn) {
      // If user is already signed in
      if (userTier && userTier !== 'free') {
        // If user has a premium tier, redirect to writer
        navigate('/writer');
      } else {
        // If free tier, show them the upgrade page, but don't force redirect
        navigate('/upgrade');
      }
    }
  }, [isSignedIn, userTier, navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
              Welcome back
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Sign in to continue to your content writer
            </p>
          </div>
          <div className="mt-8">
            <SignIn 
              routing="path" 
              path="/login" 
              afterSignInUrl="/upgrade"
              afterSignUpUrl="/upgrade"
              signUpUrl="/sign-up"
            />
          </div>
        </div>
      </div>
      <Footerdemo />
    </div>
  );
}